import {useState, useEffect} from 'react';
import Axios from 'axios'

// import zdjęć
import zdj1 from '../assets/gallery2/1.jpg'
import zdj2 from '../assets/gallery2/2.jpg'
import zdj3 from '../assets/gallery2/3.jpg'
import zdj4 from '../assets/gallery2/4.jpg'
import zdj5 from '../assets/gallery2/5.jpg'
import zdj6 from '../assets/gallery2/6.jpg'
import zdj7 from '../assets/gallery2/7.jpg'
import zdj8 from '../assets/gallery2/8.jpg'
import zdj9 from '../assets/gallery2/9.jpg'
import zdj10 from '../assets/gallery2/10.jpg'
import zdj11 from '../assets/gallery2/11.jpg'
import zdj12 from '../assets/gallery2/12.jpg'
import zdj13 from '../assets/gallery2/13.jpg'
import zdj14 from '../assets/gallery2/14.jpg'
import zdj15 from '../assets/gallery2/15.jpg'
import zdj16 from '../assets/gallery2/16.jpg'
import zdj17 from '../assets/gallery2/17.jpg'
import zdj18 from '../assets/gallery2/18.jpg'
import zdj19 from '../assets/gallery2/19.jpg'
import zdj20 from '../assets/gallery2/20.jpg'
import zdj21 from '../assets/gallery2/21.jpg'
import zdj22 from '../assets/gallery2/22.jpg'
import zdj23 from '../assets/gallery2/23.jpg'
import zdj24 from '../assets/gallery2/24.jpg'

import arkuszGaleria from '../assets/files/arkusze/inf04Galeria.zip';

// najpierw zainstalować bibliotekę bootstrap:
// npm install bootstrap
import 'bootstrap/dist/css/bootstrap.css';

// jeśli zdjęcia są w folderze public - nie trzeba ich importować
// dostep do zdjęć jest po ich ścieżce (tutaj to nie działało stąd import)

export default function Gallery2(){
  // tablica z zdjeciami
  // downloads zdjęć jest przeniesiony do bazy danych
  const zdjecia = [
    {id: 1, alt: "morze", filename: "1.jpg", href: zdj1, category:1},
    {id: 2, alt:"góry", filename: "2.jpg", href: zdj2, category:3},
    {id: 3, alt:"morze", filename: "3.jpg", href: zdj3, category:1},
    {id: 4, alt:"kwiaty", filename: "4.jpg", href: zdj4, category:2},
    {id: 5, alt:"góry", filename: "5.jpg", href: zdj5, category:3},
    {id: 6, alt:"morze", filename: "6.jpg", href: zdj6, category:1},
    {id: 7, alt:"kwiaty", filename: "7.jpg", href: zdj7, category:2},
    {id: 8, alt:"morze", filename: "8.jpg", href: zdj8, category:1},
    {id: 9, alt:"góry", filename: "9.jpg", href: zdj9, category:3},
    {id: 10, alt:"kwiaty", filename: "10.jpg", href: zdj10, category:2},
    {id: 11, alt:"morze", filename: "11.jpg", href: zdj11, category:1},
    {id: 12, alt:"morze", filename: "12.jpg", href: zdj12, category:1},
    {id: 13, alt:"góry", filename: "13.jpg", href: zdj13, category:3},
    {id: 14, alt:"góry", filename: "14.jpg", href: zdj14, category:3},
    {id: 15, alt:"morze", filename: "15.jpg", href: zdj15, category:1},
    {id: 16, alt:"góry", filename: "16.jpg", href: zdj16, category:3},
    {id: 17, alt:"morze", filename: "17.jpg", href: zdj17, category:1},
    {id: 18, alt:"góry", filename: "18.jpg", href: zdj18, category:3},
    {id: 19, alt:"kwiaty", filename: "19.jpg", href: zdj19, category:2},
    {id: 20, alt:"kwiaty", filename: "20.jpg", href: zdj20, category:2},
    {id: 21, alt:"kwiaty", filename: "21.jpg", href: zdj21, category:2},
    {id: 22, alt:"morze", filename: "22.jpg", href: zdj22, category:1},
    {id: 23, alt:"kwiaty", filename: "23.jpg", href: zdj23, category:2},
    {id: 24, alt:"kwiaty", filename: "24.jpg", href: zdj24, category:2},
    ];

  // stan poszczególnych switchy  
  const [isFlowerOn, setIsFlowerOn] = useState(true);
  const [isAnimalOn, setIsAnimalOn] = useState(true);
  const [isCarOn, setIsCarOn] = useState(true);
   
  // tablica zdjeciaPrzefiltrowane (w zależności od stanu switchy)
  // po zmianie stanu switcha strona jest powtórnie renderowana i odpala się filtrowanie
  // niepotrzebna jest tu zmienna stanu zdjeciaPrzefiltrowane
  let zdjeciaPrzefiltrowane = zdjecia.filter(zdjecie=>{
  //setGaleria(zdjeciaPrzefiltrowane.filter(zdjecie=>{      // error rerendering
    if(zdjecie.category === 1 && isFlowerOn){return true}
    if(zdjecie.category === 2 && isAnimalOn){return true}
    if(zdjecie.category === 3 && isCarOn){return true}
    return false;
  });

  
  // funkcja uruchamiana po zmianie któregoś switcha
  // ustawia stany switchy
  const handleSwitchChange = (event) => {
    const { id, checked } = event.target;
    console.log(event);
    if (id === 'morze') {
      setIsFlowerOn(checked);
      //console.log('Kwiaty:', checked);
    } else if (id === 'kwiaty') {
      setIsAnimalOn(checked);
      //console.log('Zwierzęta:', checked);
    } else if (id === 'góry') {
      setIsCarOn(checked);
      //console.log('Samochody:', checked);
    }
  };

  /**
   * korespondencja z serwerem, który pobiera dane z MySQL z bazy gallery2 
   * tabela: downloads    // tabela z liczbą pobrań dla poszczególnych zdjęć
   * pola: id             // id tabeli to równoczesnie id zdjęcia   
   *       number         // liczba pobrań dla poszczególnych zdjęć
   * 
   */

  // dostęp do bazy danych MySQL zrobione na podstawie:
  // https://dev.to/nasreenkhalid/simple-react-js-and-mysql-integration-crud-app-backend-5aom
  // https://dev.to/nasreenkhalid/simple-react-js-and-mysql-integration-crud-app-frontend-3i0l
  // https://github.com/NasreenKhalid/React-nd-MySQL-CRUD-App/tree/master/server
  
  // lista liczby downlods dla zdjęć ściagana z bazy danych
  const [numbersList,setNumbersList]=useState([]);
  // triger do updatu numberList
  const [isDownloadsIncremented,setIsDownloadsIncremented]=useState(false);

  // udate numberList z bazy danych
  useEffect(()=>{
    // wysyłamy do serwera żadanie GET pobierajace listę downloads zdjęć
    //Axios.get("https://pracownia.palacmlodziezy.lodz.pl:3002/api/getAll").then((data)=>{
    Axios.get("https://pracownia.palacmlodziezy.lodz.pl:3002/api/getAll").then((data)=>{  //PM
        setNumbersList(data.data)
        //console.log("useEffect updated numbers list")
        //console.log(data);
        setIsDownloadsIncremented(false);  // zerujemy triger updatu numberList
  });
  },[isDownloadsIncremented]) // wykonuje się po zmianie isDownloadsIncremented

  // funkcja odpowiedzialna za inkrementację zdjęć
  // po naciśnięciu przycisku - w zależności od id zdjęcia
  const incrementDownloads = (id) => {
    // wysyłamy żądanie POST do serwera dotyczące inkrementacji zdjęcia o danym id
    //Axios.post(`https://pracownia.palacmlodziezy.lodz.pl:3002/api/updateDownload/${id}`)
    Axios.post(`https://pracownia.palacmlodziezy.lodz.pl:3002/api/updateDownload/${id}`)  //PM
      .then((response) => {
        //console.log("Odpowiedź serwera:", response);
        setIsDownloadsIncremented(true);  // triger do updatu numberList 
      })
      .catch((error) => {
        console.error("Błąd podczas wysyłania żądania:", error);
    });

    /* ściaganie zdjęcia */
    // znajdujemy zdjecie w galerii po id
    const zdjecie = zdjecia.find(img => img.id === id);
    // tworzymy link do zdjecia
    const link = document.createElement('a');
    link.href = zdjecie.href;
    link.download = zdjecie.filename;
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
  };

   return (
    // musi być parent przy wielu wierszach, nawet pusty
    <div>
      <h1>Kategorie zdjęć</h1>
        {/* bootstrap */}
        <div className="form-check form-check-inline form-switch">
          <input className="form-check-input" type="checkbox" id="morze" onChange={handleSwitchChange} checked={isFlowerOn} />
          <label className="form-check-label" htmlFor="morze">morze</label>
        </div>
        <div className="form-check form-check-inline form-switch">
          <input className="form-check-input" type="checkbox" id="kwiaty" onChange={handleSwitchChange} checked={isAnimalOn} />
          <label className="form-check-label" htmlFor="kwiaty">kwiaty</label>
        </div>
         <div className="form-check form-check-inline form-switch">
          <input className="form-check-input" type="checkbox" id="góry"  onChange={handleSwitchChange} checked={isCarOn} />
          <label className="form-check-label" htmlFor="góry">Góry</label>
        </div>
        <div className="row">
          {zdjeciaPrzefiltrowane.map(zdjecie => (
              <div key={zdjecie.id} className="col" style={{height:250}}>
                  <img src={zdjecie.href} alt={zdjecie.alt} width={200} />
                  {/* Check if numbersList and the specific item exist before rendering */}
                  {/* numbersList indeksuje się od zera stąd numbersList[zdjecie.id-1] */}
                   {numbersList && numbersList[zdjecie.id-1] ? (
                      <h4>Pobrań: {numbersList[zdjecie.id-1].number}</h4>
                      ) : (
                      <h4>Loading...</h4>
                    )}
                  <button className="btn btn-success" onClick={() =>  incrementDownloads(zdjecie.id)}>Pobierz</button>
              </div>
          ))}
        </div>
        <div>
                <a href={arkuszGaleria}>arkusz Galeria</a>
        </div>
    </div>
   );
}

